import * as Constants from '../constants';
import { ApplicationStateKeys } from '../constants/ApplicationStateKeys';
import { getHost } from '../lib/configuration/TunerVarUtils';

import { getNow } from './TimeUtils';

const MAX_INLINE_ERROR_COUNT = 10;

/**
 * Has application been initialized
 *
 * @param {object} state - application state
 * @returns {boolean} true/false
 */
export function isApplicationInitialized(state: $TSFixMe): boolean {
  return !!state.application.get(ApplicationStateKeys.APPLICATION_INITIALIZED);
}

export function isApplicationOffline(state: $TSFixMe): boolean {
  return state.application && state.application.get(ApplicationStateKeys.IS_OFFLINE);
}

export function getLastOfflineAction(state: $TSFixMe): $TSFixMe {
  return state.application.get(ApplicationStateKeys.LAST_OFFLINE_ACTION);
}

/**
 * Return current count of service errors
 *
 * @param {object} state - application state
 * @returns {number} total service errors seen
 */
export function getServiceErrorCount(state: $TSFixMe): number {
  return state.application.get(ApplicationStateKeys.SERVICE_ERRORS);
}

export function isPlaylistPage(state: $TSFixMe): boolean {
  return state.application.get(ApplicationStateKeys.IS_PLAYLIST_PAGE);
}

// @todo - [WEBCLIENT-6930] This does not take into account if the 404 page is rendered by a sub-component
export function is404Page(state: $TSFixMe): boolean {
  return state.application.get(ApplicationStateKeys.IS_404_PAGE);
}

/**
 * Are we in the midst of service errors?
 *
 * @param {object} state - application state
 * @returns {boolean} true/false
 */
export function isServiceOk(state: $TSFixMe): boolean {
  return getServiceErrorCount(state) === 0;
}

/**
 * Have service errors exceeded threshold
 *
 * @param {object} state - application state
 * @returns {boolean} true/false
 */
export function hasServiceErrorCountExceededMax(state: $TSFixMe): boolean {
  return getServiceErrorCount(state) > MAX_INLINE_ERROR_COUNT;
}

/**
 * the current tab's tabId
 *
 * @param {object} state - redux state
 * @returns {boolean} true/false
 */
export function getMyTabId(state: $TSFixMe): boolean {
  return state.application.get(ApplicationStateKeys.XTAB_MY_TAB_ID);
}

/**
 * Is this the currently playing tab?
 *
 * @param {object} state - redux state
 * @returns {boolean} true/false
 */
export function isCurrentlyPlayingTab(state: $TSFixMe): boolean {
  const currentlyPlayingTabId = state.application.get(
    ApplicationStateKeys.XTAB_CURRENTLY_PLAYING_TAB_ID,
  );
  const myTabId = getMyTabId(state);
  return !currentlyPlayingTabId || myTabId === currentlyPlayingTabId;
}

export function getIsPersistingDataLocally(state: $TSFixMe): boolean {
  return state.application.get(ApplicationStateKeys.IS_PERSISTING_LOCALLY);
}

export function getIsLoggingOut(state: $TSFixMe): boolean {
  return state.application.get(ApplicationStateKeys.IS_LOGGING_OUT);
}

export function getCookieDomain(state: $TSFixMe): string {
  const host = getHost(state);
  if (host && host.match(/pandora.com$/)) {
    return '.pandora.com';
  }

  if (host && host.match(/savagebeast.com$/)) {
    return '.savagebeast.com';
  }
  return '';
}

export function generateCachebustNumber(): string {
  // Cachebust tokens should be a combination of the current timestamp
  // and a randomly generated number
  let cachebust = '' + getNow();
  // Must be smaller than max positive value of Java long
  // (9223372036854775807) so we'll restrict to 18 digits
  const digitsRemaining = 18 - cachebust.length;
  if (digitsRemaining > 0) {
    const multiplier = Math.pow(10, digitsRemaining - 1);
    const rand = Math.floor(multiplier + Math.random() * 9 * multiplier);
    cachebust += '' + rand;
  }
  return cachebust;
}

export function shouldNavigateToCommunity(state: $TSFixMe): boolean {
  return !!state.application.getIn(
    [
      Constants.ApplicationStateKeys.ApplicationStateKeys.STARTUP_QUERY_PARAMETERS,
      Constants.App.StartupQueryParameterKeys.COMMUNITY_SSO,
    ],
    false,
  );
}

export function getCustomRedirectReferer(state: $TSFixMe): $TSFixMe {
  return state.application.getIn(
    [
      Constants.ApplicationStateKeys.ApplicationStateKeys.STARTUP_QUERY_PARAMETERS,
      Constants.App.StartupQueryParameterKeys.REFERER,
    ],
    null,
  );
}

export function getCommunitySSOUrl(): string {
  return `/${Constants.Api.ApiEndpoints.COMMUNITY_SSO}`;
}
